var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.5C5.5 7.22386 5.27614 7 5 7C4.72386 7 4.5 7.22386 4.5 7.5H5.5ZM20.5 7.5C20.5 7.22386 20.2761 7 20 7C19.7239 7 19.5 7.22386 19.5 7.5H20.5ZM4.5 7.5V18H5.5V7.5H4.5ZM8 21.5H17V20.5H8V21.5ZM20.5 18V7.5H19.5V18H20.5ZM17 21.5C18.933 21.5 20.5 19.933 20.5 18H19.5C19.5 19.3807 18.3807 20.5 17 20.5V21.5ZM4.5 18C4.5 19.933 6.067 21.5 8 21.5V20.5C6.61929 20.5 5.5 19.3807 5.5 18H4.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7L10 18",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7L15 18",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7H3.5C3.5 7.27614 3.72386 7.5 4 7.5V7ZM21 7V7.5C21.2761 7.5 21.5 7.27614 21.5 7H21ZM4.5 7V5H3.5V7H4.5ZM5 4.5H20V3.5H5V4.5ZM20.5 5V7H21.5V5H20.5ZM21 6.5H4V7.5H21V6.5ZM20 4.5C20.2761 4.5 20.5 4.72386 20.5 5H21.5C21.5 4.17157 20.8284 3.5 20 3.5V4.5ZM4.5 5C4.5 4.72386 4.72386 4.5 5 4.5V3.5C4.17157 3.5 3.5 4.17157 3.5 5H4.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4V3C10 2.44772 10.4477 2 11 2H14C14.5523 2 15 2.44772 15 3V4",
    stroke: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.81c1816c.svg";
export { ForwardRef as ReactComponent };